import { CommitmentsScenariosService_commitmentScenarioVersionServiceGetEntities } from '@festina/life-general-types/life/hooks/CommitmentsScenariosService_commitmentScenarioVersionServiceGetEntities'

export const useLazyFetchScenarios =
  CommitmentsScenariosService_commitmentScenarioVersionServiceGetEntities.useLazyQuery
